import { Component, inject, OnDestroy } from '@angular/core';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { HttpErrorNotifyService } from "../../services/http-error-notify.service";

/** Скільки тримаємо повідомлення на екрані, мс */
const AUTO_HIDE_MS = 10000;

// Картка #252: глобальний блок під повідомлення інтерцептора про невдалий запит.
// Не модалка і не alert() - фонові запити падають і тоді, коли користувач
// нічого не натискав, блокувати йому екран у такому випадку не можна.
// Лежить над лоадером (z-index лоадера - 999999), бо лоадер ховається не миттєво.
@Component({
  selector: 'app-http-error-message',
  template: `
    <div class="http-error" *ngIf="isShown">
      <a class="http-error__close" (click)="close()"></a>

      <p class="http-error__title">{{ title }}</p>
      <p class="http-error__text">{{ text }}</p>
    </div>
  `,
  styles: [`
    .http-error {
      box-sizing: border-box;
      position: fixed;
      right: 16px;
      bottom: 16px;
      z-index: 1000000;
      width: 340px;
      max-width: calc(100% - 32px);
      padding: 14px 34px 14px 16px;
      border: 1px dashed #FF8D33;
      border-radius: 6px;
      background-color: #fdf6ef;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      font-family: 'Exo2Regular', sans-serif;
      font-size: 14px;
      line-height: 19px;
      color: #3b3b3b;
      text-align: left;
    }

    .http-error__title {
      margin: 0 0 6px;
      font-family: 'Exo2Bold', sans-serif;
      color: #2F3B52;
    }

    .http-error__text {
      margin: 0;
      color: #5B657A;
    }

    .http-error__close {
      position: absolute;
      width: 20px;
      height: 20px;
      right: 8px;
      top: 8px;
      background-image: url(/assets/images/icons/cros.svg);
      background-repeat: no-repeat;
      background-size: contain;
      cursor: pointer;
    }
  `]
})
export class HttpErrorMessageComponent implements OnDestroy {
  private isDestroyed: Subject<boolean> = new Subject();
  private notify = inject(HttpErrorNotifyService);
  private hideTimer: any = null;

  public isShown = false;
  public title = '';
  public text = '';

  constructor() {
    this.notify.noticeChange
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((notice) => {
        this.title = notice.title;
        this.text = notice.text;
        this.isShown = true;

        // Нове повідомлення заміщає попереднє і заново відлічує показ,
        // інакше пачка запитів, що впала разом, гасила б блок раніше часу.
        this.restartHideTimer();
      });
  }

  public close(): void {
    this.clearHideTimer();
    this.isShown = false;
  }

  private restartHideTimer(): void {
    this.clearHideTimer();
    this.hideTimer = setTimeout(() => {
      this.hideTimer = null;
      this.isShown = false;
    }, AUTO_HIDE_MS);
  }

  private clearHideTimer(): void {
    if (this.hideTimer !== null) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  ngOnDestroy() {
    this.clearHideTimer();
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
